export default __webpack_public_path__ + "static/media/category-13.fc1ca970.jpg";